import styled from 'styled-components';

const Image = styled.img.attrs((props) => ({
    src: props.image
}))``;

export { Image };
